import React from 'react';
import Product from './../product/index';
import ProductDetailInfo from '../productDetails/';
import { getPageinfoByName, emptyPageinfo, bannerStatus } from '../../action/productsAction';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { catchJSException } from './../../service/logService'
import { Utils } from '../../util/utils'
import Loader from '../../components/loader'
import { apiUrl } from '../../constants/apiUrl';
import api, {getCookieVisitIdAndVisitorId, clearCookieVisitId } from '../../service/apiService';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { redirectTo } from './../../action/redirection'
import { Pages } from '../../constants/actionType'
import { updatePageLogs, checktime } from './../../service/logService';
import * as accessoriesAction from '../../action/accessoriesAction'
import * as errorAction from './../../action/errorAction';
import * as checkoutAction from './../../action/checkoutAction';
import CustError from '../../components/custError'
import ErrorBoundary from '../../service/errorBoundary';

class WrapperProduct extends React.PureComponent {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            pageName: '',
            productloaded: false,
            productName:'',
            isProfileCallComplete:false
        }
    }
    validateVisitid(){
        let server_visitid=window.accid1
        let server_exptime=window.accexp
        if(server_visitid!==undefined && server_visitid!=="" && server_visitid!==this.props.appState.visitId){
            this.setlocalstoragevisitid(server_visitid,this.props.appState.visitorId,server_exptime,true);
            window.accid1=""
            window.accexp=""
            accessoriesAction.updateProfileCall(false,this.props.dispatch);
        }
    }
    getClientIp(){
        let clientIp = window.accip;
        if(clientIp !== undefined && clientIp !== "" && this.props.appState.clientIp === ""){
            accessoriesAction.updateClientIp(this.props.dispatch, clientIp);
            window.accip="";
        }else {
            window.accip="";
        }
    }
    checkURL=()=>{
        try{
            let queryString = this.props && this.props.location && this.props.location.search;
            if(queryString && queryString.indexOf("source=MyVerizon")>-1){
                accessoriesAction.updateMlpFlow(this.props.dispatch, true);
                let pdpPath = this.props && this.props.location && this.props.location.pathname;
                let pdpName = pdpPath.slice(pdpPath.lastIndexOf("/")+1);
                accessoriesAction.updateMlpPDP(this.props.dispatch, pdpName.replace(/-/g,' '));
                //console.log("*****************************************"+pdpName.replace(/-/g,' '));
            }
        }catch(ex){
            catchJSException('wrapperProduct', this.props.appState.visitId, 'checkURL', ex);
        }
    }
    getAcceptHeader(){
        let acceptHeader = window.acceptheader;
        if(acceptHeader !== undefined && acceptHeader !== "" && acceptHeader !== null && this.props.appState.acceptHeader === ""){
            accessoriesAction.updateAcceptHeader(this.props.dispatch, acceptHeader);
            window.acceptheader="";
        }else {
            window.acceptheader="";
        }
    }
    doservervisitidcheck()
    {
        return new Promise((resolve, reject) => {
            getCookieVisitIdAndVisitorId()
            .then(response => {
                if(response && response.data) {
                    const { server_visit_id,server_visitor_id,expirationTime} = response.data;
                    this.setlocalstoragevisitid(server_visit_id,server_visitor_id,expirationTime,true);                    
                    resolve(server_visit_id);
                }
                else
                    resolve(null);
            })
            .catch(error => {
                console.log(error);
                resolve(null);
            })
        })
    }
    resetCookieVisitId()
    {   
        return new Promise((resolve, reject) => {
            clearCookieVisitId()
            .then(response => {
                if(response && response.data) {
                    const { status } = response.data;
                    let validatePromise = this.createVisitIdAfterOrderSubmit();
                    Promise.all([validatePromise])
                        .then(
                            response => {
                                window.accid1="";
                                resolve(status);
                                checktime(this.createVisitIdAfterOrderSubmitPageLog('Mount'))
                            }
                        )
                        .catch((error) => {
                            console.log(error);
                            resolve(null);
                          });  
                }
                else
                    resolve(null);
            })
            .catch(error => {
                console.log(error);
                resolve(null);
            })
        })
    }
    setlocalstoragevisitid(visit_id,visitor_id,expirationTime,ispropsupdate)
    {
        if(ispropsupdate)
            this.props.dispatch({ type: "UPDATE_VISITID", value: { visitId:visit_id, visitorId: visitor_id } });
        // window.sessionStorage.setItem('visit_id', visit_id);
        // window.localStorage.setItem('visit_id', visit_id);
        window.sessionStorage.setItem('visit_id_vtp', visit_id);
        window.localStorage.setItem('visit_id_vtp', visit_id);
        window.localStorage.setItem('visitor_id', visitor_id);
        let expTime = expirationTime;
        if (!expTime && window.location.host.indexOf('localhost') !== -1) {
            expTime = Date.now() + 86400000 - ((((new Date().getHours()) * 60) + (new Date().getMinutes())) * 60000);
        }
        //window.localStorage.setItem('expirationTime', expTime);
        window.localStorage.setItem('expirationTime_vtp', expTime);
    }
    
    createVisitID() {
        try {            
            // this.cookie_VisitId = window.sessionStorage.getItem("visit_id");
            // let storeVisitId = window.localStorage.getItem("visit_id");
            this.cookie_VisitId = window.sessionStorage.getItem("visit_id_vtp");
            let storeVisitId = window.localStorage.getItem("visit_id_vtp");            
            // let cookie_expirationTime = parseInt(window.localStorage.getItem("expirationTime"));
            let cookie_expirationTime = parseInt(window.localStorage.getItem("expirationTime_vtp"));

            if ((this.cookie_VisitId && this.cookie_VisitId === storeVisitId && cookie_expirationTime && cookie_expirationTime > Date.now()))
            {   
                if(!this.props.categoryState.categoriesExp) {
                    accessoriesAction.getCategoriesFromAPI(this.props.dispatch)
                }
                // accessoriesAction.updateProfileCall(false,this.props.dispatch);
                this.processPageAfterVisitID();
                console.log("createvisitid api call not invoked - wrapper prod");
            }
            else //if (this.props.appState.visitId === "" || this.cookie_VisitId === '')
            {
                this.doservervisitidcheck()//check the browser cookie value from the node endpoint
                .then(response => {                    
                    if(response!=null && response !="")
                    {   
                        if(!this.props.categoryState.categoriesExp) {
                            accessoriesAction.getCategoriesFromAPI(this.props.dispatch)
                        }
                        accessoriesAction.updateProfileCall(false,this.props.dispatch);
                        this.processPageAfterVisitID();
                        console.log("createvisitid api call not invoked - wrapper prod - 1");
                        return;
                    }
                    
                    console.log("createvisitid invoked from wrapperproduct.js");
                    const visitidUrl = apiUrl().createVisitId;
                    return new Promise((resolve, reject) => {
                        <Loader></Loader>
                        api(visitidUrl, 'GET', '').then(response => {
                            if (Utils.isNotEmpty(response) && Utils.isNotEmpty(response.visit_id) && Utils.isNotEmpty(response.visitor_id)) {
                                this.setlocalstoragevisitid(response.visit_id,response.visitor_id,response.expirationTime,false);
                            }
                            console.log('cookies',this.props.cookies)
                            accessoriesAction.setCookie(this.props.cookies, response, this.props);
                            if(!this.props.categoryState.categoriesExp){
                                accessoriesAction.getCategoriesFromAPI(this.props.dispatch)
                            }
                            accessoriesAction.updateProfileCall(false,this.props.dispatch);
                            this.processPageAfterVisitID();
                            resolve(response);
                        })
                        .catch(error => {
                            reject('error-visitidcreation')
                        });
                    })
                })                
                .catch(error => {
                    console.log(error);
                })
            }            
        } catch (ex) {
            catchJSException('wrapper product', "", 'createVisitID', ex);
        }
    }
    createVisitIdAfterOrderSubmit() {
        try{
            console.log("createvisitid invoked from wrapperproduct.js createVisitIdAfterOrderSubmit");
            const visitidUrl = apiUrl().createVisitId;
            return new Promise((resolve, reject) => {
                <Loader></Loader>
                api(visitidUrl, 'GET', '').then(response => {
                    if (Utils.isNotEmpty(response) && Utils.isNotEmpty(response.visit_id) && Utils.isNotEmpty(response.visitor_id)) {
                        this.setlocalstoragevisitid(response.visit_id,response.visitor_id,response.expirationTime,false);
                    }
                    console.log('cookies',this.props.cookies)
                    accessoriesAction.setCookie(this.props.cookies, response, this.props);
                    // if(!this.props.categoryState.categoriesExp){
                    //     accessoriesAction.getCategoriesFromAPI(this.props.dispatch)
                    // }
                    // this.processPageAfterVisitID();
                    resolve(response);
                })
                .catch(error => {
                    reject('error-visitidcreation')
                });
            })
        } catch (ex) {
            catchJSException('wrapper product', "", 'createVisitIdAfterOrderSubmit', ex);
        }
    }
    processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'wrapper product',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false
        }
    })
    validUser = ((pagestate) => {
        return {
            page: 'wrapperProd_ValidUser',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    notValidUser = ((pagestate) => {
        return {
            page: 'wrapperProd_GuestCustomer',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    profileCallCheck = ((pagestate,profileCondDataValue) => {
        return {
            page: 'wrapperProd_ProfileCallCondCheck_'+profileCondDataValue,
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    createVisitIdAfterOrderSubmitPageLog = ((pagestate) => {
        //let newVisitId = window.localStorage.getItem("visit_id");
        let newVisitId = window.localStorage.getItem("visit_id_vtp");
        return {
            page: 'wrapperProd_OrderSubmit_NewVisitId',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: newVisitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })

    profilePageLog=()=>{
        if(this.props.categoryState.isValidUser){
            console.log('wrapperProd_validUser')
            checktime(this.validUser('Mount'))
        }else{
            console.log('wrapperProd_GuestCustomer')
            checktime(this.notValidUser('Mount'))
        }
    }
    getPageinfo(pageName) {
        try {
            this.setState({ productloaded: false })
            var rqstInfo = {
                "productName": pageName
            }
            let request = JSON.stringify(rqstInfo);
            let validatePromise
            if(this.props.appState.visitId===""){
                validatePromise=setTimeout(() => { getPageinfoByName(request, this.props.dispatch, this.props.appState.visitId);
                    (this.props.vtpErrors && this.props.vtpErrors.billPunchoutErrors) ? "" : errorAction.getBillPunchOutErrors(this.props.dispatch,this.props.appState.visitId);
                    (this.props.vtpErrors && this.props.vtpErrors.billingAddressValidationErrors) ? "" : errorAction.getBillingAddressValidationErrors(this.props.dispatch,this.props.appState.visitId);
                    (this.props.vtpErrors && this.props.vtpErrors.vzProfileErrors) ? "" : errorAction.getVzProfileErrors(this.props.dispatch,this.props.appState.visitId);
                    // (this.props.appState && this.props.appState.flowSubtype) ? "" : accessoriesAction.updateFlowSubType("vtp",this.props.dispatch, this.props.appState.visitId); 
                }, 2000);
                <Loader></Loader>
            }else{
                (this.props.vtpErrors && this.props.vtpErrors.billPunchoutErrors) ? "" : errorAction.getBillPunchOutErrors(this.props.dispatch,this.props.appState.visitId);
                (this.props.vtpErrors && this.props.vtpErrors.billingAddressValidationErrors) ? "" : errorAction.getBillingAddressValidationErrors(this.props.dispatch,this.props.appState.visitId);
                (this.props.vtpErrors && this.props.vtpErrors.vzProfileErrors) ? "" : errorAction.getVzProfileErrors(this.props.dispatch,this.props.appState.visitId);
                // (this.props.appState && this.props.appState.flowSubtype) ? "" : accessoriesAction.updateFlowSubType("vtp",this.props.dispatch, this.props.appState.visitId);
                validatePromise = getPageinfoByName(request, this.props.dispatch, this.props.appState.visitId);
            }
           

            // let validatePromise = getPageinfoByName(request, this.props.dispatch, this.props.appState.visitId);
            Promise.all([validatePromise])
                .then(
                    response => {
                       if(response!==null  && response!==undefined)
                       {
                            this.setState({ productloaded: true }) 
                       }
                    }
                                   )
                                   .catch((error) => {
                                    console.log(error);
                                    resolve(null);
                                  });  

        }
        catch (ex) {
            catchJSException('wrapperProduct', this.props.appState.visitId, 'willmount', ex);
        }
    }

    loadScript = (url) => {
        try {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            document.body.appendChild(script);
        }
        catch (ex) {
            catchJSException('wrapperProduct', "", 'loadScript', ex);
        }
    }

    injectDDScript = ()=>{
        try{
        document.body.setAttribute("class","kaxsdc");        
        document.body.setAttribute("data-event","load");
        let safetechMerchantId ="300637";
        let sessionId = this.props.appState && this.props.appState.visitId;
        let url="https://tst.kaptcha.com/"; /**for non-prod*/        
        let host = window.location.host;
        if ((host === "www.verizon.com")) {
            url = "https://ssl.kaptcha.com/"; 
        }
        let scriptUrl = url+"collect/sdk?m="+safetechMerchantId+"&s="+sessionId;        
        this.loadScript(scriptUrl);
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerText= `setTimeout(function () {if(typeof ka != 'undefined'){var client=new ka.ClientSDK();client.autoLoadEvents ();}},3000)`;
        document.body.appendChild(script);
        }
        catch (ex) {
            catchJSException('wrapperProduct', "", 'injectDDScript', ex);
        }
    }
    componentWillMount() {
        console.log("wrapperprod willmount"); 
        let clearVisitIdPromise;               
        if (Utils.isNotNull(this.props.orderSubmitState) && this.props.orderSubmitState.orderPlaced === "Y") {
            Utils.clearRedux("all"); 
            clearVisitIdPromise = this.resetCookieVisitId(); // triggering node endpoint to clear browser cookie visitid          
            // window.localStorage.setItem('visit_id', "");
            window.localStorage.setItem('visit_id_vtp', "");
            window.localStorage.setItem('visitor_id', "");
        } 
        
        Promise.all([clearVisitIdPromise])
        .then(
            response => {

        const { cookies } = this.props;
        let userInfo = cookies.get('userinfo');

        let oneSSOId = Utils.getCookieByPartialKey('onessoid');
        let oneV = cookies.get('oneV');
        console.log("values to check ONEVZ_TO_ACCESSORIES_ROUTE 2",userInfo, oneSSOId, oneV ,this.props.categoryState.isGuestFlow, this.props.appState.oneVzToAccessoriesRoute)
        if ((userInfo == undefined || userInfo == "" || userInfo == null) && !this.props.categoryState.isGuestFlow && ((oneSSOId != undefined && oneSSOId != "" && oneSSOId != null) || (oneV != undefined && oneV != "" && oneV != null  && oneV =="true")) && !this.props.appState.oneVzToAccessoriesRoute) {
          let pageUrlInfo  = window.location.href;
          let pageUrl = pageUrlInfo.split("accessories/");
          this.props.dispatch({ type: 'ONEVZ_TO_ACCESSORIES_ROUTE', value: true});
          let redirectUrl = apiUrl().myOneVzRoutingUrl + (pageUrl.length>0 ? pageUrl[1] : "") ;
          console.log("ONEVZ_TO_ACCESSORIES_ROUTE 2", redirectUrl)
          window.location.assign(redirectUrl);
        }

        this.validateVisitid()
        this.getClientIp();
        this.getAcceptHeader();
        let validatePromise = this.createVisitID();
        Promise.all([validatePromise])
            .then(
                response => {
                    this.checkURL();
                    let profileCondData={
                        "isUserInfo": (userInfo !== undefined && userInfo !== "" && userInfo !== null) ? true : false,
                        "isProfileCallTriggered": this.props.categoryState.isProfileCall,
                        "isGuestFlowValue": this.props.categoryState.isGuestFlow,
                        "isOrderPlaced": ((Utils.isNotNull(this.props.orderSubmitState) && 
                        this.props.orderSubmitState.orderPlaced === "Y"))? true : false
                     } 
                     let profileCondDataValue=JSON.stringify(profileCondData) 
                     checktime(this.profileCallCheck("Mount",profileCondDataValue)) 
        let isMvaFlow = window.navigator.userAgent.indexOf('VZW-MFA') > -1 ;
        if (isMvaFlow) {
            accessoriesAction.isMvaFlow(this.props.dispatch, true);
        }
        console.log("profilecall in wrapperproduct",isMvaFlow, this.props.categoryState.isProfileCall)            
        if((isMvaFlow && !this.props.categoryState.isProfileCall) || (userInfo !== undefined && userInfo !== "" && userInfo !== null && !this.props.categoryState.isProfileCall && !this.props.categoryState.isGuestFlow))
        {
            //this.createVisitID();
            if(typeof ka == "undefined"){
                this.injectDDScript() //safetech script injection
            }
            if(this.props.appState.visitId===""){
                setTimeout(() => { checkoutAction.getProfileInfo(this.props.dispatch,this.props.appState.visitId).then(
                    response=>{
                        this.setState({isProfileCallComplete: true});
                        
                        this.profilePageLog()
                    }
                    
                )
                    accessoriesAction.updateSigninApplied(true,this.props.dispatch)
                    accessoriesAction.updateFlowType("AF",this.props.dispatch)  }, 1500);
                <Loader></Loader>
            }else{
                checkoutAction.getProfileInfo(this.props.dispatch,this.props.appState.visitId).then(
                    response=>{
                        this.setState({isProfileCallComplete: true});
                        this.profilePageLog()
                    }
                   
                )  
                accessoriesAction.updateSigninApplied(true,this.props.dispatch)  
                accessoriesAction.updateFlowType("AF",this.props.dispatch)
            }   
            
            this.getPageinfo(this.props.match.params.pageName)                
        }
        else
        {
            if(typeof ka == "undefined"){
                this.injectDDScript() //safetech script injection
            }
            // let validatePromise = this.createVisitID();
            // Promise.all([validatePromise])
            // .then(
            //     response => {
                this.setState({isProfileCallComplete: true});
                    this.getPageinfo(this.props.match.params.pageName);
                    window.bannerresp="";
                    return response;
            //     }
            // )
        }
    }
 )
 .catch((error) => {
    console.log(error);
    resolve(null);
  });  
        
        // if(userInfo !== undefined && userInfo !== "" && userInfo !== null && !this.props.categoryState.isProfileCall && !this.props.categoryState.isGuestFlow)
        // {
        //     this.createVisitID();
        //     if(this.props.appState.visitId===""){
        //         setTimeout(() => { checkoutAction.getProfileInfo(this.props.dispatch,this.props.appState.visitId).then(
        //             response=>{
        //                 this.profilePageLog()
        //             }
                    
        //         )
        //             accessoriesAction.updateSigninApplied(true,this.props.dispatch)
        //             accessoriesAction.updateFlowType("AF",this.props.dispatch)  }, 1500);
        //         <Loader></Loader>
        //     }else{
        //         checkoutAction.getProfileInfo(this.props.dispatch,this.props.appState.visitId).then(
        //             response=>{
        //                 this.profilePageLog()
        //             }
                   
        //         )  
        //         accessoriesAction.updateSigninApplied(true,this.props.dispatch)  
        //         accessoriesAction.updateFlowType("AF",this.props.dispatch)
        //     }   
            
        //     this.getPageinfo(this.props.match.params.pageName)                
        // }
        // else
        // {

        //     let validatePromise = this.createVisitID();
        //     Promise.all([validatePromise])
        //     .then(
        //         response => {
        //             this.getPageinfo(this.props.match.params.pageName);
        //             window.bannerresp="";
        //             return response;
        //         }
        //     )
        // }
        emptyPageinfo(this.props.dispatch); 
        }
        )  
        .catch((error) => {
            console.log(error);
            resolve(null);
          });       
    }
    componentWillReceiveProps(nextProps) {
        // if (Utils.isNotNull(this.props.orderSubmitState) && this.props.orderSubmitState.orderPlaced === "Y") {
        //     Utils.clearRedux("all");
        //     window.localStorage.setItem('visit_id', "");
        //     window.localStorage.setItem('visitor_id', "");
        // }
        // this.createVisitID()
        let actualExpName=undefined

        let urlName=nextProps.match.params.pageName;

        // let categoryList=this.props.categoryState.categoriesExp
        // let productList=this.props.productState.productsExp
        // let featuredAcessoriesList=this.props.categoryState.featuredAccessoriesExp
        // let othersViewedList=(this.props.othersViewedState.otherValue===undefined)?undefined:this.props.othersViewedState.otherValue


        if (urlName !== this.state.pageName) {
            this.setState({
                pageName: nextProps.match.params.pageName,
            });
            // this.getPageinfo(nextProps.match.params.pageName)
            actualExpName=nextProps.match.params.pageName
            //this.cookie_VisitId = window.localStorage.getItem("visit_id");
            this.cookie_VisitId = window.localStorage.getItem("visit_id_vtp");
            if (this.props.appState.visitId != "" && this.cookie_VisitId != '') {
            this.getPageinfo(actualExpName)  
            } 
        }
    }
    render() {
        // return wells.length ? this.renderWells() : (
        //     <span>Loading wells...</span>
        //   )
        // let productObj = "<span> </span>"
        <Loader></Loader>
         let productObj = ""
         
        if (this.props.productState.bannerCallStatus!= undefined && !(this.props.productState.bannerCallStatus)){
            /** Renders Error page if post banner call return null */
            productObj=<CustError></CustError>
        }
        if (this.state.productloaded) {
            
            let pageinfo = this.props.productState.pageinfo

            if (pageinfo && pageinfo.categoryId && pageinfo.productId && this.state.isProfileCallComplete) {
                //if banner post api is returning categoryid and productid then need to route it to 
                //product details page
                productObj = <ErrorBoundary><ProductDetailInfo props={this.props} /></ErrorBoundary>;
            }
            else if (pageinfo && pageinfo.categoryId && (!pageinfo.productId) && this.state.isProfileCallComplete) {
                //if banner post api is returning categoryid alone then need to route it to 
                //products page
                productObj = <ErrorBoundary><Product props={this.props} /></ErrorBoundary>;
            }else{
                productObj ="";
            }

            return (
                <React.Fragment>
                    <Loader/>
                    {productObj}
                </React.Fragment>

            );
        }
        else {
            return (
                <React.Fragment>
                    <Loader/>
                    {productObj}
                </React.Fragment>
            )
        }
    }
}


//export default withRouter (connect()(WrapperProduct));
const mapStateToProps = (state) => {
    return {
        appState: state.appVTP,
        productState: state.productsVTP,
        categoryState:state.categoriesVTP,
        othersViewedState:state.prodDetailsVTP,
        orderSubmitState: state.orderSubmitVTP,
        vtpErrors : state.errorVTP

    }
}
export default withCookies(withRouter(connect(
    mapStateToProps
)(WrapperProduct)));
